export default __webpack_public_path__ + "static/media/bandsite-desktop-revised.c9691534.jpg";